import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getCurrentYear, getInlineLoader } from "../Helpers"

export default function Footer() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const marketplaceLinks = [
    { item: 'home', label: 'Home' },
    { item: 'books', label: 'Books' },
    { item: 'videos', label: 'Videos' },
    { item: 'journals', label: 'Journals' },
    { item: 'stories', label: 'Stories' },
  ];

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    return (
      <footer className="MainBodySection marketplace-footer bg-dark">
        <div className="container">
          <div className="row g-4">
            <div className="col-12 col-md-4">
              <h6 className="marketplace-footer-title">Marketplace</h6>
              {
                marketplaceLinks.map((link) => {
                  return (
                    <button
                      className="marketplace-footer-link"
                      key={link.item}
                      onClick={() => appContext.navTo({ item: link.item })}
                    >
                      {link.label}
                    </button>
                  )
                })
              }
            </div>

            <div className="col-12 col-md-4">
              <h6 className="marketplace-footer-title">MIKA KENYATA</h6>
              <p>
                A digital marketplace for books, videos, journals and stories.
              </p>
            </div>

            <div className="col-12 col-md-4">
              <h6 className="marketplace-footer-title">Your Library</h6>
              <p>
                Customer accounts, purchases and secure content access will be introduced next.
              </p>
              <button
                className="btn btn-primary btn-rounded"
                onClick={() => appContext.navTo({ item: 'account' })}
              >
                Account
              </button>
            </div>

            <div className="col-12 text-center marketplace-footer-bottom">
              <hr/>
              <p>&copy; MIKA KENYATA - {getCurrentYear()}</p>
              
            </div>
          </div>
        </div>
      </footer>
    )
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
